import { AccountTypeEnum } from "~/graphql/supergraphEnums";

// Maps main's PascalCase investor_account_type vocabulary to compliance-backend's
// lowercase AccountTypeEnum; mirrors AccountTypeEnum.map_from_common_data_model_value.
export const MAIN_ACCOUNT_TYPE_TO_ACCOUNT_TYPE: Readonly<Record<string, AccountTypeEnum>> = {
  Corporation: AccountTypeEnum.Corporation,
  Individual: AccountTypeEnum.Individual,
  IRA: AccountTypeEnum.Ira,
  Joint: AccountTypeEnum.Joint,
  JointOther: AccountTypeEnum.JointOther,
  LLC: AccountTypeEnum.Llc,
  NonProfit: AccountTypeEnum.NonProfit,
  "501c3": AccountTypeEnum.Field_501c3,
  Other: AccountTypeEnum.Other,
  Partnership: AccountTypeEnum.Partnership,
  TIC: AccountTypeEnum.Tic,
  Trust: AccountTypeEnum.Trust,
  IRAorNonUS: AccountTypeEnum.IraOrNonUs,
  SelfDirectedIRA: AccountTypeEnum.SelfDirectedIra,
  RevocableTrust: AccountTypeEnum.RevocableTrust,
  IrrevocableTrust: AccountTypeEnum.IrrevocableTrust,
  DAC: AccountTypeEnum.Dac,
  SARL: AccountTypeEnum.Sarl,
  SA: AccountTypeEnum.Sa,
  PTC: AccountTypeEnum.Ptc,
  SPC: AccountTypeEnum.Spc,
  LLP: AccountTypeEnum.Llp,
  LTD: AccountTypeEnum.Ltd,
  GMBH: AccountTypeEnum.Gmbh,
  AG: AccountTypeEnum.Ag,
  PLC: AccountTypeEnum.Plc,
  LLLP: AccountTypeEnum.Lllp,
  Foundation: AccountTypeEnum.Foundation,
  EmployeePension: AccountTypeEnum.EmployeePension,
  PensionPlan: AccountTypeEnum.PensionPlan,
  Sovereign: AccountTypeEnum.Sovereign,
  Custodian: AccountTypeEnum.Custodian,
};

const COMPLIANCE_ACCOUNT_TYPES = new Set<string>(Object.values(AccountTypeEnum));

export const accountTypeFromMainAccountType = (
  mainAccountType: string | null | undefined,
): AccountTypeEnum | null => {
  if (!mainAccountType) return null;
  const mapped = MAIN_ACCOUNT_TYPE_TO_ACCOUNT_TYPE[mainAccountType];
  if (mapped) return mapped;
  return COMPLIANCE_ACCOUNT_TYPES.has(mainAccountType)
    ? (mainAccountType as AccountTypeEnum)
    : null;
};
